import { render, staticRenderFns } from "./product_favorite_selector.vue?vue&type=template&id=4f008eee&"
import script from "./product_favorite_selector.vue?vue&type=script&lang=js&"
export * from "./product_favorite_selector.vue?vue&type=script&lang=js&"
import style0 from "./product_favorite_selector.vue?vue&type=style&index=0&id=4f008eee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports